module.exports = __webpack_public_path__ + "img/1467256065.aeab596e.jpg";